<template>
  <div class="headModule" :style="`background:${info.toolbar_background_color};`">
    <img :src="logo_module" alt />
    <mask-btn-group
      @moveUp="$emit('moveUp',idx)"
      @moveDown="$emit('moveDown',idx)"
      @edit="$emit('edit',idx)"
      @del="$emit('del',idx)"
      :info="info"
      :idx="idx"
    ></mask-btn-group>
  </div>
</template>

<script>
import maskBtnGroup from './maskBtnGroup';
import logo_module from '@imgs/logo_module.png';

export default {
  name: 'headModule',
  props: {
    idx: [String, Number],
    info: Object,
  },
  data: () => ({
    logo_module,
  }),
  components: {
    maskBtnGroup,
  },
};
</script>

<style lang="scss" scoped>
.headModule {
  position: relative;
  width: 375px;
  height: 44px;
  padding-top: 10px;
  text-align: center;
  img {
    width: 48px;
    height: 24px;
  }
}
</style>